import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalFrequencyCappingRules = lazy(() =>
  import("@scenes/GlobalFrequencyCappingRules").then((module) => ({
    default: module.default.GlobalFrequencyCappingRules,
  }))
);

export const frequencyCappingRulesNRO: NavigationRoutingObject = {
  Component: GlobalFrequencyCappingRules,
  section: "settings",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("frequency-capping-rules-sidebar-pill-menu-option", "Frequency Capping Rules"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("frequency-capping-rules-description", "Manage Frequency Capping Rules"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroup", { permission: "viewFrequencyCaps" });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("global-message-settings", "Global Message Settings"), t("manage-settings", "Manage Settings")],
      description: t(
        "previously-global-message-settings",
        'Previously "Global Message Settings" in "Manage Settings"'
      ),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
